import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import WidgetGraph from "./WidgetGraph";
import somethingWentWrong from "../../../../assets/No_Data_Found.svg";
import WidgetHeader from "./Header";
import "../../pdfdownload/pdfdownload.css";
import {
  deepCopy,
  getAllDeepDiveDashboardFilters,
  getAllFilters,
  getAllShareFilters,
  getAllTemplateFilters,
  getGlobalBrands,
  getMtdYtdDuration,
  getPaneIndex,
  getWidgetGraphObject,
  useQuery,
} from "../../../../redux/constants";
import { memo } from "react";
import useScrollStopListener from "../../dashboard/useScrollStopListener";
import { useInView } from "react-intersection-observer";
import {
  setPageChart,
  setWidgetMakerGraphData,
  setWidgetMakerShareGraphData,
  setWidgetMakerSharePageGraphData,
} from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setAggregateData,
  setGraphData,
  setGraphShareFetch,
} from "../../../../redux/actions/ApiCall";
import isEqual from "react-fast-compare";
import { supportedBenchmarkTraceDashboardTypes } from "../../../../redux/constants/enums";
import WidgetNote from "./WidgetNote";

const WidgetCard = ({
  propsId,
  data,
  widgets,
  section_id,
  widget_index,
  section_index,
  sections,
  widget_id,
  nextWidgetdata,
  prevWidgetdata,
  isDeepdiveDashboardView = false,
}) => {
  let graphData = data?.graphData ? data?.graphData : data?.persist_graphdata;

  const dispatch = useDispatch();
  let query = useQuery();
  let graphData1 = data?.graphData || data?.persist_graphdata ? data : widgets;
  const editPanelInfo = useSelector((state) => state?.dashboard?.editPanelInfo);
  const isWidgetEdit = useSelector((state) => state?.Filter?.isWidgetEdit);
  const Section = useSelector((state) => state?.Section?.addSection);
  const sectionReorderingInprogress = useSelector(
    (state) => state?.Section?.sectionReorderingInprogress
  );
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  let index = getPaneIndex(panes, activeKey);
  const section = panes[index]?.section;
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const graphLoader = useSelector((state) => state?.apiCall?.loader); //display chart loader

  const templateDetails = useSelector(
    (state) => state?.Section?.templateDetails
  );
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);

  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const widgetUpdateFilterLoader = useSelector(
    (state) => state?.ApiCall?.widget_update_filter_loader
  );
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  const profileFilterList = deepdiveDashboardTemplateData
    ? deepdiveDashboardTemplateData?.profile_filters_list
    : window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
      window.location.pathname?.split("/")?.[1] === "create-dashboard"
    ? templateDetails?.profile_filters_list
    : panes?.[index]?.profile_filters_list;

  const share_selected_deepdive_widget = useSelector(
    (state) => state?.Share?.share_selected_deepdive_widget
  );

  // Section Case
  const { ref, inView, entry } = useInView({
    // trackVisibility: true,
    delay: 10,
    // threshold: 0,
    // rootMargin: "300px 20px 300px 40px",
    root: document,
    rootMargin: `${window.innerHeight * 0.6}px 20px ${
      window.innerHeight * 0.6
    }px 40px`,
    threshold: 0.0,
  });

  const LoadMoreSections = (
    section_index,
    widget_index,
    data,
    widgets,
    entry_id
  ) => {
    global.TabActiveKey = null;

    // console.log("Share list",
    // shareTemplateData?.dashboard_called_api_list, entry_id)
    let shareTemplateDataUpdatedList = global.shareTemplateApiCalledList
      ? global.shareTemplateApiCalledList
      : shareTemplateData?.dashboard_called_api_list;

    let templateDetailsApiCalledList = global.templateDetailsApiCalledList
      ? global.templateDetailsApiCalledList
      : templateDetails?.dashboard_called_api_list;

    // console.log("main templateDetailsApiCalledList",
    // templateDetailsApiCalledList, entry_id)

    let pathName = window.location.pathname?.split("/")?.[1];

    if (
      isDeepdiveDashboardView ||
      (!shareBrands && panes?.[index]?.isDeepDiveDashboard) ||
      (shareBrands && shareTemplateData?.isDeepDiveDashboard)
    ) {
      let deepDiveDashboardApiCalledList = global.deepDiveDashboardApiCalledList
        ? global.deepDiveDashboardApiCalledList
        : deepdiveDashboardTemplateData?.dashboard_called_api_list;
      let dashboardDeepDiveViewLoaded =
        isDeepdiveDashboardView ||
        (!shareBrands && panes?.[index]?.isDeepDiveDashboard) ||
        (shareBrands && shareTemplateData?.isDeepDiveDashboard);
      if (
        !widgetUpdateFilterLoader &&
        dashboardDeepDiveViewLoaded &&
        ((data && !data?.graphData) || (widgets && !widgets?.data)) &&
        (!deepdiveDashboardTemplateData?.dashboard_called_api_list ||
          (deepdiveDashboardTemplateData?.dashboard_called_api_list &&
            !deepdiveDashboardTemplateData?.dashboard_called_api_list?.includes(
              entry_id
            )))
      ) {
        let duration = deepdiveDashboardData?.duration
          ? deepdiveDashboardData?.duration
          : deepdiveDashboardData?.from
          ? {
              from: deepdiveDashboardData?.from,
              to: deepdiveDashboardData?.to,
            }
          : deepdiveDashboardData?.start_date
          ? {
              from: deepdiveDashboardData?.start_date,
              to: deepdiveDashboardData?.end_date,
            }
          : null;
        let global_brands = deepdiveDashboardData?.brands;
        let brandsContainter = {
          brand_ids: data?.brand_ids,
          brand_groups: data?.brand_groups,
          singleBrands: shareBrands ? shareBrands?.brand_list : brands,
          brandGroupList: shareBrands
            ? shareBrands?.brand_groups
            : brandlogicalgroup,
        };

        let filter = getAllDeepDiveDashboardFilters(
          graphConditionConfig,
          deepdiveDashboardData,
          deepdiveDashboardTemplateData,
          section_index,
          widget_index,
          brandsContainter
        );
        // View Dashboard Profile FIlter case
        let widget_metadata =
          deepdiveDashboardTemplateData?.sections?.[section_index]?.widgets?.[
            widget_index
          ];

        let widget_profile_filter_list = widget_metadata?.profile_filters_list;

        let section_profile_filter_list =
          deepdiveDashboardTemplateData?.sections?.[section_index]
            ?.profile_filters_list;

        let indexes = {
          section_index: section_index,
          widget_index: widget_index,
          widget_id: widgets?.widget_id ? widgets?.widget_id : widget_id,
          graph_type: data ? data?.graph_type : widgets?.graph_type,
          section_id: section_id,
          deepdiveDashboardTemplateData: deepdiveDashboardTemplateData,
          deepdiveDashboardData: deepdiveDashboardData,
          isDeepdiveDashboard: true,
        };

        let obj = {};
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = data;
        obj.deepdiveDashboardData = deepdiveDashboardData;
        obj.deepdiveDashboardTemplateData = deepdiveDashboardTemplateData;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.widget = widgets;
        obj.temporary_words = temporary_words;
        obj.brandlogicalgroup = brandlogicalgroup;
        obj.brands = brands;
        obj.graphConditionConfig = graphConditionConfig;
        obj.authParams = authParams;
        obj.type = "deepdive_dashboard";
        obj.profile_filters = widget_metadata?.profile_filters
          ? widget_metadata?.profile_filters
          : null;
        obj.profile_filters_list =
          widget_metadata?.is_locked && widget_profile_filter_list?.length > 0
            ? widget_profile_filter_list
            : section_profile_filter_list?.length > 0
            ? section_profile_filter_list
            : profileFilterList;
        obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
        obj.filter_by_data = widget_metadata?.filter_by_data;
        obj.filter_by = widget_metadata?.filter_by;

        obj.filter_dropdown = widget_metadata?.filter_dropdown
          ? widget_metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
          ? widget_metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
          ? widget_metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        widgetGraphObject.isNetworkChartV2 =
          widgetGraphObject?.chart?.chart_type === "network-graph-v2"
            ? true
            : false;
        if (!shareBrands) {
          if (
            widgetGraphObject?.x_axis ||
            widgetGraphObject?.y_series ||
            widgetGraphObject?.chart
          ) {
            if (
              graphConditionConfig?.[`data-source`]?.includes(
                widgetGraphObject?.data_source
              )
            ) {
              dispatch(setPageChart(authParams, widgetGraphObject, indexes));
            } else {
              dispatch(
                setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
              );
            }
          } else {
            if (authParams) {
              widgetGraphObject && widgetGraphObject?.graph_type === "aggregate"
                ? dispatch(
                    setAggregateData(
                      widgetGraphObject,
                      indexes //widget data
                    )
                  )
                : dispatch(
                    setGraphData(
                      widgetGraphObject,
                      indexes //widget data
                    )
                  );
            }
          }
        } else {
          indexes.shareBrands = shareBrands;
          if (
            widgetGraphObject?.x_axis ||
            widgetGraphObject?.y_series ||
            widgetGraphObject?.chart
          ) {
            graphConditionConfig?.[`data-source`]?.includes(
              widgetGraphObject?.data_source
            )
              ? dispatch(
                  setWidgetMakerSharePageGraphData(
                    widgetGraphObject,
                    shareCategory,
                    indexes,
                    null,
                    query?.get("share_id")
                  )
                )
              : dispatch(
                  setWidgetMakerShareGraphData(
                    widgetGraphObject,
                    shareCategory,
                    indexes,
                    null,
                    query?.get("share_id")
                  )
                );
          } else {
            dispatch(
              setGraphShareFetch(
                widgetGraphObject,
                shareCategory,
                indexes,
                null,
                query?.get("share_id")
              )
            );
          }
        }
      }
    } else if (
      // profileFilterList &&
      (pathName === "edit-dashboard" || pathName === "create-dashboard") &&
      !shareBrands &&
      !sectionReorderingInprogress &&
      ((data && !data?.graphData) || (widgets && !widgets?.data)) &&
      (!templateDetailsApiCalledList ||
        (templateDetailsApiCalledList &&
          !templateDetailsApiCalledList?.includes(entry_id)))
    ) {
      let sectionObj = {
        filters: templateDetails?.templateFilters,
        quick_filter_value: templateDetails?.quick_filter_value,
        hidden_filter: templateDetails?.hidden_filter,
        adsset_value: templateDetails?.adsset_value,
        ads_value: templateDetails?.ads_value,
      };
      let filter = getAllTemplateFilters(
        graphConditionConfig,
        Section,
        section_index,
        widget_index,
        sectionObj
      );

      let indexes = {
        section_index: section_index,
        templateFilter: true,
        widget_index: widget_index,
        widget_id: widgets?.widget_id ? widgets?.widget_id : widget_id,
        section: Section,
        graph_type: widgets?.graph_type,
        template_details: templateDetails,
        section_id: section_id,
      };

      let sectionObjN = {
        // brand_ids: response?.data?.result?.brand_ids,
        // brand_groups: response?.data?.result?.brand_groups,
        // singleBrands: paneobject?.singleBrands,
        brandFilters: Section?.[section_index ? section_index : 0]?.brandFilters
          ? Section?.[section_index ? section_index : 0]?.brandFilters
          : [],
        filters: Section?.[section_index ? section_index : 0]?.filters
          ? Section?.[section_index ? section_index : 0]?.filters
          : [],
        duration: Section?.[section_index ? section_index : 0]?.duration
          ? Section?.[section_index ? section_index : 0]?.duration
          : null,
        dateFilters: Section?.[section_index ? section_index : 0]?.dateFilters
          ? Section?.[section_index ? section_index : 0]?.dateFilters
          : [],
        is_locked: Section?.[section_index ? section_index : 0]?.is_locked
          ? Section?.[section_index ? section_index : 0]?.is_locked
          : false,
        comp_brand_type:
          Section?.[section_index ? section_index : 0]?.comp_brand_type ===
            false ||
          Section?.[section_index ? section_index : 0]?.comp_brand_type === true
            ? Section?.[section_index ? section_index : 0]?.comp_brand_type
            : null,
        quick_filter_value: templateDetails?.quick_filter_value,
      };
      let widgetObj = {
        // brand_groups: widget?.brand_groups,
        // singleBrands: paneobject?.singleBrands,
        filters: widgets?.filters ? widgets?.filters : [],
        duration: {
          from: widgets?.start_date
            ? widgets?.start_date
            : widgets?.dateFilters?.from
            ? widgets?.dateFilters?.from
            : null,
          to: widgets?.end_date
            ? widgets?.end_date
            : widgets?.dateFilters?.to
            ? widgets?.dateFilters?.to
            : null,
        },
        is_locked: widgets?.is_locked ? widgets?.is_locked : false,
      };

      let duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;

      let global_brands =
        templateDetails?.templateBrands?.columns?.length > 0
          ? templateDetails?.templateBrands?.columns
          : templateDetails?.templateBrands?.length > 0
          ? templateDetails?.templateBrands
          : null;

      // edit dashboard profile filters
      let widget_metadata =
        section_index >= 0
          ? Section?.[section_index]?.data?.[widget_index]
          : Section?.[0]?.data?.[widget_index];

      let widget_profile_filter_list =
        section_index >= 0
          ? Section?.[section_index]?.data?.[widget_index]?.profile_filters_list
          : Section?.[0]?.data?.[widget_index]?.profile_filters_list;

      let section_profile_filter_list =
        section_index >= 0
          ? Section?.[section_index]?.profile_filters_list
          : Section?.[0]?.profile_filters_list;

      let obj = {};
      obj.section_index = section_index;
      obj.widget_index = widget_index;
      obj.data = data;

      obj.competition_aggregation =
        supportedBenchmarkTraceDashboardTypes?.includes(
          templateDetails?.template_type
        )
          ? templateDetails?.competition_aggregation || "avg"
          : null;
      obj.template_type = templateDetails?.template_type;
      obj.public_engagement_only =
        templateDetails?.public_engagement_only || false;
      obj.duration = duration;
      obj.global_brands = global_brands;
      obj.filter = filter;
      obj.widget = widgets;
      obj.temporary_words = temporary_words;
      obj.brandlogicalgroup = brandlogicalgroup;
      obj.brands = brands;
      obj.graphConditionConfig = graphConditionConfig;
      obj.authParams = authParams;
      obj.sectionObj = sectionObjN;
      obj.widgetObj = widgetObj;
      obj.type = "template";
      obj.profile_filters = widget_metadata?.profile_filters
        ? widget_metadata?.profile_filters
        : null;
      obj.profile_filters_list =
        widget_metadata?.is_locked && widget_profile_filter_list?.length > 0
          ? widget_profile_filter_list
          : section_profile_filter_list?.length > 0
          ? section_profile_filter_list
          : profileFilterList;
      obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
      obj.filter_by_data = widget_metadata?.filter_by_data;
      obj.filter_by = widget_metadata?.filter_by;
      obj.data_source = widget_metadata?.data_source
        ? widget_metadata?.data_source
        : "mentions";

      obj.filter_dropdown = widget_metadata?.filter_dropdown
        ? widget_metadata?.filter_dropdown
        : [];
      obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
        ? widget_metadata?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
        ? widget_metadata?.filter_by_dropdown_data
        : [];

      let widgetGraphObject = getWidgetGraphObject(obj);
      widgetGraphObject.isNetworkChartV2 =
        widgetGraphObject?.chart?.chart_type === "network-graph-v2"
          ? true
          : false;

      if (
        widgetGraphObject?.x_axis ||
        widgetGraphObject?.y_series ||
        widgetGraphObject?.chart
      ) {
        if (
          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
        ) {
          dispatch(setPageChart(authParams, widgetGraphObject, indexes));
        } else {
          dispatch(
            setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
          );
        }
      } else {
        if (authParams) {
          widgetGraphObject && widgetGraphObject?.graph_type === "aggregate"
            ? dispatch(
                setAggregateData(
                  widgetGraphObject,
                  indexes //widget data
                )
              )
            : dispatch(
                setGraphData(
                  widgetGraphObject,
                  indexes //widget data
                )
              );
        }
      }
    } else if (
      // profileFilterList &&
      !widgetUpdateFilterLoader &&
      (pathName === "dashboard" || pathName === "pin-dashboard") &&
      panes?.[index]?.isDashboard &&
      !shareBrands &&
      ((data && !data?.graphData) || (widgets && !widgets?.data)) &&
      (!panes?.[index]?.dashboard_called_api_list ||
        (panes?.[index]?.dashboard_called_api_list &&
          !panes?.[index]?.dashboard_called_api_list?.includes(entry_id))) &&
      !panes?.[index]?.is_widget_maker_open_obj?.open_flag // This flag added due to edit widget maker development
    ) {
      let duration = panes?.[index]?.duration;

      // let global_brands = getGlobalBrands(
      //   panes[index]?.brands,
      //   global_dashboard_single_brands,
      //   global_dashboard_brands,
      //   panes[index]?.template_type
      // );
      let global_brands = panes?.[index]?.brands;

      let sectionObj = {
        filters: templateDetails?.templateFilters,
      };

      let widgetObj = {
        brand_groups: data?.brand_groups,
        singleBrands: brands,
      };

      let filter = getAllFilters(
        graphConditionConfig,
        panes,
        index,
        section_index,
        widget_index,
        brandlogicalgroup,
        data?.brand_ids, //logical brand change
        widgetObj
      );

      let indexes = {
        pane_index: index,
        // section_index: section_index ? section_index : null,
        // section_index: widgets ? null : section_index,
        section_index: section_index,
        panes: panes,
        widget_index: widget_index,
        widget_id: widgets?.widget_id ? widgets?.widget_id : widget_id,
        graph_type: data ? data?.graph_type : widgets?.graph_type,
        templateFilter: widgets ? true : false,

        section_id: section_id,
      };

      // View Dashboard Profile FIlter case
      let widget_metadata =
        section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
          : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

      let widget_profile_filter_list =
        section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.profile_filters_list
          : panes?.[index]?.section?.[0]?.widgets?.[widget_index]
              ?.profile_filters_list;

      let section_profile_filter_list =
        section_index >= 0
          ? panes?.[index]?.sections?.[section_index]?.profile_filters_list
          : panes?.[index]?.section?.[0]?.profile_filters_list;

      let obj = {};
      obj.section_index = section_index;
      obj.widget_index = widget_index;
      obj.data = data;
      obj.panes = panes;
      obj.paneIndex = index;
      obj.duration = duration;
      obj.global_brands = global_brands;
      obj.filter = filter;
      obj.widget = widgets;
      obj.temporary_words = temporary_words;
      obj.brandlogicalgroup = brandlogicalgroup;
      obj.brands = brands;
      obj.graphConditionConfig = graphConditionConfig;
      obj.authParams = authParams;
      obj.type = "view";
      obj.profile_filters = widget_metadata?.profile_filters
        ? widget_metadata?.profile_filters
        : null;
      obj.profile_filters_list =
        widget_metadata?.is_locked && widget_profile_filter_list?.length > 0
          ? widget_profile_filter_list
          : section_profile_filter_list?.length > 0
          ? section_profile_filter_list
          : profileFilterList;
      obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
      obj.filter_by_data = widget_metadata?.filter_by_data;
      obj.filter_by = widget_metadata?.filter_by;
      obj.data_source = widget_metadata?.data_source
        ? widget_metadata?.data_source
        : "mentions";

      obj.filter_dropdown = widget_metadata?.filter_dropdown
        ? widget_metadata?.filter_dropdown
        : [];
      obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
        ? widget_metadata?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
        ? widget_metadata?.filter_by_dropdown_data
        : [];

      let widgetGraphObject = getWidgetGraphObject(obj);
      widgetGraphObject.isNetworkChartV2 =
        widgetGraphObject?.chart?.chart_type === "network-graph-v2"
          ? true
          : false;

      if (
        widgetGraphObject?.x_axis ||
        widgetGraphObject?.y_series ||
        widgetGraphObject?.chart
      ) {
        if (
          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
        ) {
          dispatch(setPageChart(authParams, widgetGraphObject, indexes));
        } else {
          dispatch(
            setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
          );
        }
      } else {
        if (authParams) {
          widgetGraphObject && widgetGraphObject?.graph_type === "aggregate"
            ? dispatch(
                setAggregateData(
                  widgetGraphObject,
                  indexes //widget data
                )
              )
            : dispatch(
                setGraphData(
                  widgetGraphObject,
                  indexes //widget data
                )
              );
        }
      }
    } else if (
      shareBrands &&
      shareCategory &&
      ((data && !data?.graphData) || (widgets && !widgets?.data)) &&
      (!shareTemplateDataUpdatedList ||
        (shareTemplateDataUpdatedList &&
          !shareTemplateDataUpdatedList?.includes(entry_id)))
    ) {
      let duration = {
        // global duration  -->dateData
        from: sharedDuration?.from,
        to: sharedDuration?.to,
      };

      let filter = getAllShareFilters(
        graphConditionConfig,
        shareTemplateData,
        section_index,
        widget_index,
        shareBrands
      );

      let indexes = {
        section_index: section_index,
        widget_index: widget_index,
        shareTemplateData: shareTemplateData,
        section_id: section_id,
        widget_id: widget_id,
      };
      let share = {
        sections: shareTemplateData,
      };

      // Shared Dashboard Case
      let widget_metadata =
        section_index >= 0
          ? shareTemplateData?.sections?.[section_index]?.widgets?.[
              widget_index
            ]
          : shareTemplateData?.section?.[0]?.widgets?.[widget_index];

      let section_profile_filters_list =
        section_index >= 0
          ? shareTemplateData?.sections?.[section_index]?.profile_filters_list
          : shareTemplateData?.section?.[0]?.profile_filters_list;

      // let profile_filter = section_index >= 0
      //   ? shareTemplateData?.sections?.[section_index]?.widgets
      //     ?.[widget_index]?.profile_filters
      //   : shareTemplateData?.section?.[0]?.widgets?.[widget_index]
      //       ?.profile_filters;

      let widgetDefaultFilters;
      if (widget_metadata?.profile_filters_list?.length) {
        widgetDefaultFilters = {
          columns: [
            {
              name: widget_metadata?.profile_filters_list?.[0]?.id,
              type: "include",
              display_name: widget_metadata?.profile_filters_list?.[0]?.name,
              profile_channel:
                widget_metadata?.profile_filters_list?.[0]?.channel,
              brand_id: widget_metadata?.profile_filters_list?.[0]?.brand_id,
            },
          ],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
      }

      let sectionDefaultFilters;
      if (section_profile_filters_list?.length) {
        sectionDefaultFilters = {
          columns: [
            {
              name: section_profile_filters_list?.[0]?.id,
              type: "include",
              display_name: section_profile_filters_list?.[0]?.name,
              profile_channel: section_profile_filters_list?.[0]?.channel,
              brand_id: section_profile_filters_list?.[0]?.brand_id,
            },
          ],
          attribute: "SocialMediaProfiles",
          type: "varchar",
        };
      }

      let quickFilterAttribute =
        shareTemplateData?.allow_multiple_selection &&
        shareTemplateData?.quick_filter_value
          ? ["AccountID", "SettingID"]?.includes(
              shareTemplateData?.quick_filter_value?.attribute
            )
            ? "AccountID"
            : shareTemplateData?.quick_filter_value?.attribute
          : shareTemplateData?.quick_filter
          ? ["AccountID", "SettingID"]?.includes(
              shareTemplateData?.quick_filter?.attribute
            )
            ? "AccountID"
            : shareTemplateData?.quick_filter?.attribute
          : shareTemplateData?.quick_filter?.attribute;

      let obj = {};
      obj.type = "share_dashboard";
      obj.section_index = section_index;
      obj.widget_index = widget_index;
      obj.data = data;
      obj.shareTemplateData = shareTemplateData;
      obj.duration = duration;
      //obj.defaultBrands=defaultBrands;
      obj.filter = filter;
      // obj.widget=widget;
      // obj.temporary_words=temporary_words;
      obj.shareBrands = shareBrands;
      obj.graphConditionConfig = graphConditionConfig;
      //obj.authParams = authParams;
      obj.profile_filters = widget_metadata?.profile_filters
        ? widget_metadata?.profile_filters
        : !widget_metadata?.profile_filters &&
          widget_metadata?.is_locked &&
          widgetDefaultFilters
        ? widgetDefaultFilters
        : section_profile_filters_list?.length && !widget_metadata?.is_locked
        ? sectionDefaultFilters
        : !widget_metadata?.is_locked &&
          quickFilterAttribute !== "AccountID" &&
          shareTemplateData?.profile_filters;
      // obj.profile_filters_list = section_profile_filters_list ? section_profile_filters_list : profileFilterList;
      obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
      obj.filter_by_data = widget_metadata?.filter_by_data;
      obj.filter_by = widget_metadata?.filter_by;
      obj.data_source = widget_metadata?.data_source
        ? widget_metadata?.data_source
        : "mentions";

      obj.filter_dropdown = widget_metadata?.filter_dropdown
        ? widget_metadata?.filter_dropdown
        : [];
      obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
        ? widget_metadata?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
        ? widget_metadata?.filter_by_dropdown_data
        : [];

      let widgetGraphObject = getWidgetGraphObject(obj);
      widgetGraphObject.isNetworkChartV2 =
        widgetGraphObject?.chart?.chart_type === "network-graph-v2"
          ? true
          : false;
      // console.log("widget card widgetGraphObject share", widgetGraphObject);
      if (
        widgetGraphObject?.x_axis ||
        widgetGraphObject?.y_series ||
        widgetGraphObject?.chart
      ) {
        graphConditionConfig?.[`data-source`]?.includes(
          widgetGraphObject?.data_source
        )
          ? dispatch(
              setWidgetMakerSharePageGraphData(
                widgetGraphObject,
                shareCategory,
                indexes,
                share,
                query?.get("share_id")
              )
            )
          : dispatch(
              setWidgetMakerShareGraphData(
                widgetGraphObject,
                shareCategory,
                indexes,
                share,
                query?.get("share_id")
              )
            );
      } else {
        dispatch(
          setGraphShareFetch(
            widgetGraphObject,
            shareCategory,
            indexes,
            share,
            query?.get("share_id")
          )
        );
      }
    }
  };

  useEffect(() => {
    if (inView && (!data?.graphData || !widgets?.data) && entry?.target?.id) {
      LoadMoreSections(
        section_index,
        widget_index,
        data,
        widgets,
        entry?.target?.id
      );
    }
  }, [
    inView,
    widgetUpdateFilterLoader,
    graphLoader,
    profileFilterList,
    templateDetails,
    sectionReorderingInprogress,
  ]);

  // Check if blurry loader should be shown
  const shouldShowBlurryLoader =
    data?.persist_graphdata && !data?.graphData && !widgets?.data;
  return (
    <>
      {/* View Dashboard Case */}
      {graphData ? (
        <div
          className={`col-12 pl-0 ${
            data?.span === "half"
              ? "col-md-6 widget_half"
              : data?.span === "one_third"
              ? "col-md-4 widget_one_third"
              : data?.span === "two_third"
              ? "col-md-8 widget_two_third"
              : "col-md-12 widget_full"
          }`}
        >
          <div
            className={`Dashboard__Widget portlet p-0 mb-15 border-radius-4 overflow-hidden ${
              ((sections &&
                sections?.[section_index ? section_index : 0]?.widgets?.[
                  widget_index
                ]?.type === "predefined" &&
                sections?.[section_index ? section_index : 0]?.widgets?.[
                  widget_index
                ]?.widget_id !== "000-700-001") ||
                (section &&
                  section?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.type === "predefined" &&
                  section?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.widget_id !== "000-700-001")) &&
              "predefined_border"
            }`}
            style={{
              border: sections
                ? sections?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.is_locked
                  ? "0.1rem solid #FFDB4D"
                  : isWidgetEdit &&
                    editPanelInfo?.widget_index === widget_index &&
                    editPanelInfo?.section_index === section_index
                  ? "0.1rem solid #678bff"
                  : "0.1rem solid #678bff33"
                : section?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.is_locked
                ? "0.1rem solid #FFDB4D"
                : isWidgetEdit && editPanelInfo?.widget_index === widget_index
                ? "0.1rem solid #678bff"
                : "0.1rem solid #678bff33",
              boxShadow: "none",
              position: "relative",
            }}
          >
            <WidgetGraph
              data={data}
              dashboard={true}
              section_id={section_id}
              widget_index={widget_index}
              section_index={section_index}
              propsId={propsId}
              sections={sections}
              span_data={Section?.[section_index]?.data[widget_index]}
            />
            {data?.note && (
              <WidgetNote
                note={data?.note}
                isPdfPreview={false}
                customclass={"widgetCard--note--content-nonpdf"}
              />
            )}
            {/* Blurry loader overlay */}
            {shouldShowBlurryLoader && (
              <div
                className="widget-blurry-loader"
                ref={ref}
                id={widget_id + "#" + section_id + "#" + widget_index}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : !widgets?.data || (data && !graphData && !data?.persist_graphdata) ? (
        <>
          {/* When Graph Data is not get, Loader and header is showing case */}
          <div
            className={`col-12 pl-0  ${
              data?.span === "half"
                ? "col-md-6 widget_half"
                : data?.span === "one_third"
                ? "col-md-4 widget_one_third"
                : data?.span === "two_third"
                ? "col-md-8 widget_two_third"
                : "col-md-12 widget_full"
            }`}
          >
            <div
              className={`Dashboard__Widget portlet p-0 mb-15 border-radius-4 ${
                (sections &&
                  sections?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.type === "predefined" &&
                  sections?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.widget_id !== "000-700-001") ||
                (Section &&
                  Section?.[section_index ? section_index : 0]?.data?.[
                    widget_index
                  ]?.type === "predefined" &&
                  Section?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.widget_id !== "000-700-001")
                  ? "predefined_border"
                  : ""
              }`}
              ref={ref}
              id={widget_id + "#" + section_id + "#" + widget_index}
            >
              <div
                ref={ref}
                id={widget_id + "#" + section_id + "#" + widget_index}
                className="Dashboard__Widget--header"
              >
                <WidgetHeader
                  widget_name={
                    data?.widget_name
                      ? data?.widget_name
                      : graphData1?.widget_name
                  }
                  widget_description={
                    data?.widget_description
                      ? data?.widget_description
                      : graphData1?.widget_description
                  }
                  section_id={section_id}
                  widget_id={data?.widget_id ? data?.widget_id : data?.id}
                  widget_index={widget_index}
                  section_index={section_index}
                  graph_type={graphData1?.graph_type}
                  chart_type={
                    graphData?.graph_type
                      ? graphData?.graph_type
                      : data?.chart?.chart_type
                  }
                  widgets={graphData1}
                  template_widget={
                    data?.graphData || data?.persist_graphdata ? false : true
                  }
                  dashboard={
                    data?.graphData || data?.persist_graphdata ? true : false
                  }
                  sections={sections}
                  allData={graphData1}
                  widHeaderLoader={true}
                  pane_section={panes?.[index]?.section}
                  selectedDeepdiveWidget={
                    shareTemplateData
                      ? share_selected_deepdive_widget
                      : panes?.[index]?.selected_deepdive_widget
                  }
                  templateAccessType={panes?.[index]?.access_type}
                  widgetData={data}
                />
              </div>
              <div className="Dashboard__Widget--body portlet1 border-0 box-shadow-none ">
                <div
                  className="loader"
                  style={{
                    height:
                      data?.span === "full" && data?.chart?.chart_type === "kpi"
                        ? "15rem"
                        : data?.span !== "full" &&
                          data?.graph_type === "kpi" &&
                          (nextWidgetdata?.graph_type === "kpi" ||
                            prevWidgetdata?.graph_type === "kpi")
                        ? "15rem"
                        : "45rem",
                  }}
                >
                  <div
                    ref={ref}
                    className="lds-ring"
                    id={widget_id + "#" + section_id + "#" + widget_index}
                  >
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        widgets && (
          <>
            {/* Edit and Create Dashboard Case */}
            <div
              id={data?.widget_id}
              className={`Dashboard__Widget portlet p-0 border-radius-4 overflow-hidden ${
                (sections &&
                  sections?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.type === "predefined" &&
                  sections?.[section_index ? section_index : 0]?.widgets?.[
                    widget_index
                  ]?.widget_id !== "000-700-001") ||
                (Section &&
                  Section?.[section_index ? section_index : 0]?.data?.[
                    widget_index
                  ]?.type === "predefined" &&
                  Section?.[section_index ? section_index : 0]?.data?.[
                    widget_index
                  ]?.widget_id !== "000-700-001")
                  ? "predefined_border"
                  : ""
              }`}
              style={{
                border:
                  Section &&
                  Section?.[section_index ? section_index : 0]?.data?.[
                    widget_index
                  ]?.is_locked
                    ? "0.1rem solid #FFDB4D"
                    : "0.1rem solid #678bff33",
                boxShadow: "none",
              }}
            >
              <WidgetGraph
                data={widgets}
                template_widget={true}
                section_id={section_id}
                widget_index={widget_index}
                section_index={section_index}
                propsId={propsId}
                sections={sections}
                span_data={Section[section_index]?.data[widget_index]}
              />
              {widgets?.note && (
                <WidgetNote
                  note={widgets?.note}
                  isPdfPreview={false}
                  customclass={"widgetCard--note--content-nonpdf"}
                />
              )}
            </div>
          </>
        )
      )}
    </>
  );
};

export default React.memo(WidgetCard, isEqual);
